<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <factor-tree-query ref="factor-tree" :factor-tree="factorTree" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <trend-related-chart-wrapper
        :data-list="dataList"
        :unit-prop="unitProp"
        :download-name="downloadName"
        :factors="filterFactors"
        show-list
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import FactorTreeQuery from '../../../../components/Data/Query/FactorTreeQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import TrendRelatedChartWrapper from '../../../../components/Data/TrendRelatedChartWrapper'

export default {
  name: 'StatisticalAnalysisBC',
  routeInfo: {
    label: '黑碳数据',
    icon: 'fa fa-eye'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, FactorTreeQuery, CompletedQuery, DataWrapper, TrendRelatedChartWrapper},
  data: () => ({
    query: {
      isFuse: false,
      isGetInvalidData: true,
      isMultipleIntegral: true
    },
    dimension: 1
  }),
  computed: {
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.BLACK_CARBON_DEVICE_CATEGORY)
    ],
    minSiteSelectNumber: () => 2,
    isSetAllFactorIds: () => 1,
    downloadName: () => '黑碳数据'
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/05Site-Compare/04BC/index.vue